module.exports = "mutation DeleteAttribute($attributeId:ID!){deleteAttribute(attributeId:$attributeId){success}}"